module.exports = __webpack_public_path__ + "img/mt5-icon12.c6a0c66.png";